export const getVRS = (sig: `0x${string}`) => {
  const r = "0x" + sig.substring(2).substring(0, 64)
  const s = "0x" + sig.substring(2).substring(64, 128)
  const v = "0x" + sig.substring(2).substring(128, 130)

  return { v, r, s }
}
